module.exports = __webpack_public_path__ + "img/20200801_130633.9de95218.jpg";